import { Routes } from '@angular/router';
import { InscriptionEntreprise } from './pages/inscription-entreprise/inscription-entreprise';
import { InscriptionRdv } from './pages/inscription-rdv/inscription-rdv';

export const routes: Routes = [
	{ path: 'inscription-entreprise', component: InscriptionEntreprise },
	{ path: 'inscription-rdv/:slug', component: InscriptionRdv },
	{ path: '', redirectTo: 'inscription-entreprise', pathMatch: 'full' },
];
